export default class ProposalItemChildrenPriceAdjustmentError extends Error {
    
}